import type { RecruiterWorkspace } from '@/types/recruiterProject';

/** Select option / chip label: project name, plus client when client-owned. */
export function formatRecruiterWorkspaceLabel(
  workspace: Pick<RecruiterWorkspace, 'name' | 'client_company'>,
): string {
  const clientName = workspace.client_company?.name?.trim();
  if (!clientName) {
    return workspace.name;
  }
  return `${workspace.name} (${clientName})`;
}
